import { z } from 'zod';

export const FormSchema = z.object({
  ma_dv: z.string().min(1, { message: 'Mã dịch vụ không được để trống' }),
  ten_dv: z.string().min(1, { message: 'Tên dịch vụ không được để trống' }),
  ten_dv2: z.string().min(1, { message: 'Tên dịch vụ không được để trống' }),

  status: z.number().min(1, { message: 'Trạng thái không được để trống' })
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  ma_dv: '',
  ten_dv: '',
  ten_dv2: '',

  status: 1
};
